import axios from 'axios';
import CONFIG from '../config';
import router from '../_router';
import store from '../_store';

const api = axios.create({
    baseURL: CONFIG.API_ROOT,
});

// console.log
// const token = ''//store.getters['authentication/token'];

api.interceptors.request.use((config) => {
    const token = store.getters['authentication/token'];
    config.headers = {
        ...config.headers,
        'Content-Type': 'application/json',
        Authorization: (token) ? `Token ${token}` : '',
    };
    return config;
});

api.interceptors.response.use(response => response, (error) => {
    // Manage error status
    // console.log(error.response)
    if (!error.response) throw error;
    if (error.response.status === 401) {
        router.push({ name: 'home' });
    }
});

export default api;

// const axios = require('axios');
// const store = require('../_store/store');

// const api = {
//     vue_router_tracks(student, fromRouteName, fromParams, toRouteName, toParams, timestamp) {
//         return axios.post(
//             'http://localhost:8070/api/tracking/vue-router-tracks/',
//             {
//                 student,
//                 from_route_rame: fromRouteName,
//                 from_params: fromParams,
//                 to_route_name: toRouteName,
//                 to_params: toParams,
//                 timestamp,
//             },
//             {
//                 headers: {
//                     Authorization: `Token ${store.default.getters.token}`,
//                     'Content-Type': 'application/json',
//                 },
//             },
//         );
//     },
//     login(username, password) {
//         return axios.post(
//             'http://localhost:8070/api/authentication/rest-auth/login/',
//             {
//                 username,
//                 password,
//             },
//         );
//     },
//     logout() {
//         return axios.post(
//             'http://localhost:8070/api/authentication/rest-auth/logout/',
//             {
//                 headers: {
//                     Authorization: `Token ${store.default.getters.token}`,
//                     'Content-Type': 'application/json',
//                 },
//             },
//         );
//     },
//     careers() {
//         return axios.get(
//             'http://localhost:8070/api/careers/careers/',
//             {
//                 headers: {
//                     Authorization: `Token ${store.default.getters.token}`,
//                     'Content-Type': 'application/json',
//                 },
//             },
//         );
//     },
//     recommend_career() {
//         return axios.get(
//             `http://localhost:8070/api/careers/recommendation/career/student/${store.default.getters.student_uuid}`,
//             {
//                 headers: {
//                     Authorization: `Token ${store.default.getters.token}`,
//                     'Content-Type': 'application/json',
//                 },
//             },
//         );
//     },
// };

// exports.api = api;
